'use client';
import React, { useEffect, useRef, useState } from 'react';

export default function TryBeforeYouBuy() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.15 }
    );
    if (sectionRef?.current) observer?.observe(sectionRef?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-12 lg:py-16 px-6 lg:px-12 max-w-7xl mx-auto">
      <div
        className={`grid grid-cols-1 lg:grid-cols-2 gap-8 items-center rounded-2xl overflow-hidden border border-gray-100 shadow-sm transition-all duration-600 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        {/* Image side */}
        <div className="relative bg-primary/5 aspect-[4/3] lg:aspect-auto lg:h-full min-h-[280px] overflow-hidden">
          <div className="absolute inset-0 flex items-center justify-center">
            <img
              src="/assets/images/collage-1787037856709.jpeg"
              alt="Try Before You Buy - Eco Packaging Collage"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute bottom-4 left-4 bg-primary text-white text-xs font-semibold px-3 py-1.5 rounded-full shadow">
            Sample Kit Available
          </div>
        </div>

        {/* Content side */}
        <div className="p-8 lg:p-10">
          <h2
            className="text-2xl md:text-3xl font-bold text-primary-dark mb-4"
            style={{ fontFamily: 'Fraunces, serif' }}
          >
            Not sure? Start with a sample.
          </h2>
          <div className="space-y-3 mb-6">
            <p className="flex items-start gap-2 text-sm font-normal text-gray-600">
              <span className="text-primary font-bold mt-0.5">✓</span>
              Touch, feel, and test your packaging before committing to a full run
            </p>
            <p className="flex items-start gap-2 text-sm font-normal text-gray-600">
              <span className="text-primary font-bold mt-0.5">✓</span>
              Evaluate materials, print finish, and structural quality — all in your hands
            </p>
            <p className="flex items-start gap-2 text-sm font-normal text-gray-600">
              <span className="text-primary font-bold mt-0.5">✓</span>
              Curated kits built for your industry:
            </p>
            <ul className="ml-6 space-y-1">
              <li className="text-sm font-normal text-gray-500 list-disc">E-commerce packaging kit</li>
              <li className="text-sm font-normal text-gray-500 list-disc">Apparel & fashion kit</li>
              <li className="text-sm font-normal text-gray-500 list-disc">Conference & events kit</li>
            </ul>
          </div>
          <a href="#contact" className="btn-primary inline-flex items-center gap-2">
            Request Sample Kit
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
}
